export default __webpack_public_path__ + "static/media/largerangingpot.2c56fb82.PNG";